import { anyOverlayOpen } from './overlay';

/**
 * Globale Tastenkürzel:
 *   Strg/Cmd+K  Suche (Command-Palette)
 *   /           Suchfeld der Liste (sonst Palette)
 *   N           Neu (Button mit data-nn-new)
 *   Esc         schließt Drawer/Modal (siehe overlay.js)
 */
export function registerShortcuts() {
    const openPalette = () => window.dispatchEvent(new CustomEvent('nn-palette-open'));

    document.addEventListener('keydown', (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
            event.preventDefault();
            openPalette();
            return;
        }

        const typing = event.target.closest?.('input, textarea, select, [contenteditable="true"], .ts-wrapper, .nn-inline');
        if (typing || event.metaKey || event.ctrlKey || event.altKey || event.isComposing) return;
        if (anyOverlayOpen() || document.body.classList.contains('nn-palette-open')) return;

        if (event.key === '/') {
            event.preventDefault();
            const search = document.querySelector('[data-nn-search]');
            if (search) {
                search.focus();
                search.select();
            } else {
                openPalette();
            }
        } else if (event.key === 'n' || event.key === 'N') {
            const button = document.querySelector('[data-nn-new]');
            if (button) {
                event.preventDefault();
                button.click();
            }
        }
    });
}
